import { JsonConvert, JsonConverter, JsonCustomConvert, JsonObject, JsonProperty } from "json2typescript";
import { BaseResponse } from "./base-response";
import { EventStatus, EventStatusConverter } from "./event-status";

@JsonConverter
export class ArrayDeviceTimelineConverter implements JsonCustomConvert<Array<DeviceTimeline>>{
	serialize() { }
	deserialize(data: any): Array<DeviceTimeline> {
		const jsonConvert: JsonConvert = new JsonConvert();
		return jsonConvert.deserializeArray(data, DeviceTimeline);
	}
}

@JsonConverter
export class DeviceLogConverter implements JsonCustomConvert<DeviceLog>{
	serialize() { }
	deserialize(data: any): DeviceLog {
		const jsonConvert: JsonConvert = new JsonConvert();
		return jsonConvert.deserializeObject(data, DeviceLog);
	}
}

@JsonObject("DeviceTimeline")
export class DeviceTimeline {
    @JsonProperty("tag", String, true)
	tag: string = "";
    @JsonProperty("count", Number, true)
	count: number = 0|1;
}

@JsonObject("DeviceLog")
export class DeviceLog {
    @JsonProperty("timestamp", Number, true)
	timestamp: number = 0;
    @JsonProperty("log_message", String, true)
	log_message: string = "";
    @JsonProperty("status", EventStatusConverter, true)
	status: EventStatus = EventStatus.UNDEFINED;
}

@JsonObject("DeviceTimelineData")
export class DeviceTimelineData extends BaseResponse{
	@JsonProperty("data", ArrayDeviceTimelineConverter, true)
	data:Array<DeviceTimeline> = new Array<DeviceTimeline>();
}

@JsonObject("DeviceLogData")
export class DeviceLogData extends BaseResponse{

}